import { formatFirstDayOfTheMonth, formatMonthDate } from '../../../utils/date';

import {
  ActiveSettlementMethodQuery,
  BillStatementsQuery,
} from 'apollo/queries/autogenerate/operations';
import { BillStatementStatusV2 } from 'apollo/queries/autogenerate/schemas';

export function getBillDueDate(
  isUsingAutoDebit: boolean,
  bill: BillStatementsQuery['billStatements'][0],
  activeSettlementMethod: ActiveSettlementMethodQuery | undefined
) {
  const dueAt = bill.dueAt;

  if (isUsingAutoDebit && activeSettlementMethod) {
    return formatMonthDate(
      activeSettlementMethod.activeSettlementMethod.settlementMethods.autoDebit
        .nextPullDate,
      'M月D日'
    );
  }

  const settlementPeriod =
    bill.statusV2 === BillStatementStatusV2.OVERDUE
      ? activeSettlementMethod?.activeSettlementMethod.settlementMethods.combini
          .settlementPeriodEnd
      : dueAt;

  const dueFrom = formatFirstDayOfTheMonth(settlementPeriod, 'M月D日');

  const dueTo = formatMonthDate(settlementPeriod, 'M月D日');

  return `${dueFrom} - ${dueTo}`;
}
